import React from "react"

const getYoutubeId = url => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    const match = url.match(regExp)

    if (match && match[2].length === 11) {
        return match[2]
    } else {
        return "error"
    }
}

const YoutubeEmbed = ({ url }) => {
    const youtubeId = getYoutubeId(url)
    const embedUrl = `https://www.youtube.com/embed/${youtubeId}?rel=0`

    return (
        <div
            className="articleContent--youtubeEmbed"
            style={{
                overflow: "hidden",
                position: "relative",
                paddingTop: "56.25%",
                height: 0,
            }}>
            <iframe
                width="420"
                height="315"
                src={embedUrl}
                frameborder="0"
                allowFullScreen
                style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                }}
            />
        </div>
    )
}

export default YoutubeEmbed

//className="articleContent--slide--iframe"
// width: "100%",
// height: "100%",
//"min-width": "100px !important",
